import _ from 'underscore'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Metrics from 'pages/MaintenanceTrends/Metrics'
import Groups from 'pages/MaintenanceTrends/Groups'
import Trends from 'pages/MaintenanceTrends/Trends'

import Tabs, { Tab } from 'components/Tabs'

import useDeviceMetrics from 'hooks/useDeviceMetrics'

import { PageTitle, screenSize, SinglePanePage } from 'styles/shared'

const TABS = [
  { header: 'Metrics', detailsComponent: Metrics },
  { header: 'Groups', detailsComponent: Groups },
  { header: 'Trends', detailsComponent: Trends }
]

const MaintenanceTrends = () => {
  useDeviceMetrics()

  const location = useLocation()
  const navigate = useNavigate()
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const pathname = location.pathname

  useEffect(() => {
    if (pathname.includes('device_metrics')) {
      setActiveTabIndex(0)
    } else if (pathname.includes('groups')) {
      setActiveTabIndex(1)
    } else if (pathname.includes('trends')) {
      setActiveTabIndex(2)
    }
  }, [pathname])

  const onTabChange = (index) => {
    setActiveTabIndex(index)
    if (index === 0) {
      navigate('/admin/device_metrics')
    } else if (index === 1) {
      navigate('/admin/groups')
    } else {
      navigate('/admin/trends')
    }
  }

  return (
    <SinglePanePage>
      <PageTitle>Maintenance Trends</PageTitle>
      <Tabs
        tabpage="others"
        activeTabIndex={activeTabIndex}
        onSelectTabIndexCallback={(index) => onTabChange(index)}
        tabItems={
          _.map(TABS, r => {
            const item: Tab = {
              key: r.header,
              header: <S.Header>{r.header}</S.Header>,
              details: <r.detailsComponent />
            }

            return item
          })
        }
      />
    </SinglePanePage>
  )
}

const S = {
  Header: styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;

    @media ${screenSize.small} {
      justify-content: flex-end;
    }
  `
}

export default MaintenanceTrends
